import { Injectable, inject, signal } from '@angular/core';
import { Observable, of, shareReplay, tap, catchError, map } from 'rxjs';
import { AdminDashboardService } from '../../admin-dashboard/services/admin-dashboard.service';

@Injectable({ providedIn: 'root' })
export class TestModeService {
  private dashboardService = inject(AdminDashboardService);

  readonly testModeEnabled = signal<boolean>(false);
  readonly loaded = signal<boolean>(false);

  private inflight$: Observable<boolean> | null = null;

  ensureLoaded(): Observable<boolean> {
    if (this.loaded()) {
      return of(this.testModeEnabled());
    }
    if (!this.inflight$) {
      this.inflight$ = this.dashboardService.getEnvironment().pipe(
        map(env => env?.testMode?.enabled === true),
        tap(enabled => {
          this.testModeEnabled.set(enabled);
          this.loaded.set(true);
        }),
        catchError(() => {
          this.testModeEnabled.set(false);
          this.loaded.set(true);
          return of(false);
        }),
        shareReplay(1),
      );
    }
    return this.inflight$;
  }
}
